import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang, ui } from '../i18n/LanguageContext';
import { team } from '../mock/data';
import { PageHero } from './About';
import { PersonPhoto } from '../components/PersonPhoto';
import useReveal from '../hooks/useReveal';

const Team = () => {
  const { t } = useLang();
  useReveal();

  return (
    <div>
      <PageHero
        tag={t(ui.team.tag)}
        title={t(ui.team.title)}
        image="https://customer-assets-rejwkqb3.emergentagent.net/job_transition-familiale/artifacts/zp5fk61p_20240106_CEF_218%20%281%29.webp"
      />

      <section className="py-16 md:py-24">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8">
          <p className="text-lg text-muted-foreground max-w-3xl mb-14 leading-relaxed reveal">{t(ui.team.intro)}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
            {team.map((m, i) => (
              <Link key={m.slug} to={`/equipe/${m.slug}`} className="group reveal" style={{ transitionDelay: `${(i % 4) * 90}ms` }}>
                <div className="img-zoom aspect-[3/4] mb-5 bg-secondary">
                  <PersonPhoto name={m.name} photo={m.photo} className="w-full h-full group-hover:grayscale-0 transition-all duration-700" />
                </div>
                <h3 className="font-serif text-xl group-hover:text-champagne transition-colors flex items-start justify-between gap-2">
                  {m.name}
                  <ArrowUpRight size={17} className="shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-sm text-champagne mt-1">{t(m.role)}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
